var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout, Auth } from "~/core/decorator";
import NumberRange from "~/components/common/number-range.vue";
import selectEntrusted from "~/components/outsource-manage/case-allot/select-entrusted.vue"; // 选择受托方
import { PageService } from "~/utils/page.service";
import { SystemParamService } from "~/services/management-service/system-param.service";
import { OutsourceStayService } from "~/services/domain-service/outsource-stay-manage.service";
import { SortService } from "~/utils/sort.service";
import { MENU_CHANNEL } from "~/config/enum.config";
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
var StayManage = /** @class */ (function (_super) {
    __extends(StayManage, _super);
    function StayManage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dialog = {
            selectEntrusted: false,
            caseDistribution: false
        };
        _this.queryModel = {
            batchNumber: "",
            caseNumber: "",
            personalName: "",
            area: "",
            mobileNo: "",
            idCard: "",
            localAddress: "",
            currentCollector: "",
            overduePeriod: "",
            turnSource: "",
            productCategory: "",
            productName: "",
            followInTime: [],
            followupBack: "",
            outAmount: {
                max: "",
                min: ""
            },
            caseMoney: { min: "", max: "" },
            overdueDays: {
                max: "",
                min: ""
            },
            labelName: []
        };
        _this.stayDataList = []; //数据列表
        _this.selectionList = []; //选中数据
        _this.caseDistributionDataList = {}; //选中数据
        _this.temp = {}; //选中数据
        _this.tempData = [];
        return _this;
    }
    StayManage.prototype.mounted = function () {
        this.refreshData();
    };
    StayManage.prototype.division = function () {
        if (this.selectionList.length === 0) {
            this.$message.info("请选择待分配案件");
            return;
        }
        this.dialog.selectEntrusted = true;
    };
    StayManage.prototype.refreshData = function () {
        var _this = this;
        // 默认加载列表
        this.outsourceStayService
            .searchPendingList(this.queryModel, this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.stayDataList = data;
            _this.selectionList = [];
        });
    };
    Object.defineProperty(StayManage.prototype, "selectedCaseIds", {
        get: function () {
            return this.selectionList.map(function (v) { return v.id; });
        },
        enumerable: false,
        configurable: true
    });
    /**
     * 进入查看执行页
     */
    StayManage.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Outsource_await,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    // 重置numberRange
    StayManage.prototype.follFeedback = function () {
        this.queryModel.outAmount = { min: "", max: "" };
        this.queryModel.overdueDays = { min: "", max: "" };
        this.queryModel.caseMoney = { min: "", max: "" };
    };
    __decorate([
        Dependencies(SystemParamService)
    ], StayManage.prototype, "sysParamService", void 0);
    __decorate([
        Dependencies(PageService)
    ], StayManage.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], StayManage.prototype, "sortService", void 0);
    __decorate([
        Dependencies(OutsourceStayService)
    ], StayManage.prototype, "outsourceStayService", void 0);
    StayManage = __decorate([
        Auth(1002),
        Layout("workspace"),
        Component({
            components: {
                GetLabelName: GetLabelName,
                NumberRange: NumberRange,
                selectEntrusted: selectEntrusted
            }
        })
    ], StayManage);
    return StayManage;
}(Vue));
export default StayManage;
